import loadable from '@loadable/component';
import { NO_SSR } from 'shared/constants/loadable';

export const NewbuildingBrokerCallbackWidgetAdapterLoadable = loadable(
  () =>
    import('./NewbuildingBrokerCallbackWidgetAdapter').catch(
      /* istanbul ignore next */ () => ({ NewbuildingBrokerCallbackWidgetAdapter: () => null }),
    ),
  {
    resolveComponent: ({ NewbuildingBrokerCallbackWidgetAdapter }) => NewbuildingBrokerCallbackWidgetAdapter,
    ssr: NO_SSR,
  },
);
